/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import initialState from '../../../../initialState';
import * as actions from './Passport-Action';

const passportReducer = (state = initialState.payment.passport, action) => {
    switch (action.type) {
        case actions.setPassportData().type:
            return {
                ...state,
                passportData: action.data.passportData,
            };
        case actions.subscribePassport().type:
            return {
                ...state,
                passportOrderItemId: action.data.orderItemId,
            };
        case actions.unSubscribePassport().type:
            return {
                ...state,
                passportOrderItemId: '',
            };
        case actions.loadPassportTncContent().type:
            return {
                ...state,
                tncContent: action.data.tncContent,
            };
        case actions.showPassportModalToRemoveGC().type:
            return {
                ...state,
                showPassportConsentToRmGC: true,
            };
        case actions.hidePassportModalToRemoveGC().type:
            return {
                ...state,
                showPassportConsentToRmGC: false,
            };
        case actions.passportProcessStart().type:
            return {
                ...state,
                passportProcess: 1,
            };
        case actions.passportProcessEnd().type:
            return {
                ...state,
                passportProcess: 0,
            };
        case actions.loadPassportDynamicCharge().type:
            return {
                ...state,
                dynamicPassportCharge: action.data.dynamicPassportCharge,
            };
        case actions.setPassportBundleData().type:
            return {
                ...state,
                passportBundle: action.data.passportBundle,
            };
        default:
            return state;
    }
};

export default passportReducer;
